import { clearAllBodyScrollLocks } from 'body-scroll-lock'
import { useRouter } from 'next/router'
import { transparentize, rem } from 'polished'
import React from 'react'
import styled, { css } from 'styled-components'
import { ICON_SIZE } from 'components/Icon'
import { Flex } from 'components/Layout'
import Link from 'components/Link'
import { Text } from 'components/Typography'
import { COLOR, SPACE, FONT_WEIGHT, FONT_SIZE, BORDER_WIDTH } from 'Theme'
import { useMedia } from 'useMedia'

const borderStyle = `border-left: ${SPACE.PX_5} solid ${COLOR.PRIMARY_1};`

export const Wrapper = styled(Flex)`
  text-decoration: none;
  ${({ isMobile, isSubOption, isLast }) => {
    if (isMobile) {
      const composedStyle = (style) => `
        margin: 0 ${SPACE.PX_15};
        ${
          !isLast &&
          `border-bottom: ${BORDER_WIDTH.PX_1} solid ${COLOR.GRAYSCALE_5};`
        }
        ${style}
      `
      if (isSubOption) {
        return composedStyle(`
          margin-left: ${rem(74)};
          padding-left: 0;
        `)
      }
      return composedStyle
    }
    if (isSubOption) {
      return css`
        padding-left: ${rem(46)};
        border-left: ${SPACE.PX_5} solid transparent;
      `
    }
    return css`
      border-left: ${SPACE.PX_5} solid transparent;
    `
  }};
  cursor: pointer;
  ${({ isActive, isMobile, isSubOption }) =>
    isActive && !isMobile && !isSubOption && borderStyle}
  &:hover {
    ${({ isMobile }) =>
      !isMobile &&
      css`
        background-color: ${transparentize(0.9, COLOR.PRIMARY_1)};
        ${borderStyle}
      `}
  }
`

interface NavLinkProps {
  label?: string
  isSubOption?: boolean
  icon?: React.ElementType
  href: string
  isLast?: boolean
}

export const NavLink: React.FC<React.PWC<NavLinkProps>> = ({
  label,
  children,
  href,
  icon: Icon,
  isSubOption,
  isLast,
  ...rest
}) => {
  const router = useRouter()
  const media = useMedia()
  const isMobile = media.MOBILE
  const isActive = router?.pathname === href
  return (
    <Link href={href} {...rest}>
      <Wrapper
        height={{ MOBILE: rem(54), TABLET: rem(40) }}
        pl={isMobile ? SPACE.PX_30 : SPACE.PX_15}
        alignItems="center"
        isActive={isActive}
        isMobile={isMobile}
        isSubOption={isSubOption}
        isLast={isLast}
        onClick={() => {
          clearAllBodyScrollLocks()
        }}
      >
        <Flex alignItems="center">
          {Icon && !isMobile && (
            <Flex
              width={SPACE.PX_20}
              height={SPACE.PX_20}
              mr={SPACE.PX_10}
              alignItems="center"
              justifyContent="center"
            >
              <Icon
                color={isActive ? COLOR.PRIMARY_1 : COLOR.GRAYSCALE_2}
                size={ICON_SIZE.PX_18}
              />
            </Flex>
          )}
          {label ? (
            <Text
              fontWeight={isActive ? FONT_WEIGHT.MEDIUM : FONT_WEIGHT.NORMAL}
              color={isActive ? COLOR.PRIMARY_1 : COLOR.GRAYSCALE_2}
              fontSize={{ MOBILE: FONT_SIZE.PX_16, TABLET: FONT_SIZE.PX_14 }}
            >
              {label}
            </Text>
          ) : (
            children
          )}
        </Flex>
      </Wrapper>
    </Link>
  )
}
